import React, {FC} from "react";
import {Controlled as CodeMirror} from "react-codemirror2";

import "../../node_modules/codemirror/lib/codemirror.css";
import "../../node_modules/codemirror/theme/material.css";
import "../styles/CodeMirror.css";

require("codemirror/mode/sql/sql");
require("codemirror/mode/xml/xml");

interface ISQLEditor {
    sql: string;
    sqlChanged: (v: string) => void;
    disabled?: boolean;
}

export const SQLEditor: FC<ISQLEditor> = ({sql, sqlChanged, disabled}) => {
    return (
        <CodeMirror
            value={sql ?? ""}
            className={"medium-codemirror"}
            options={{
                mode: "text/x-sql",
                lineNumbers: true,
                readOnly: disabled,
            }}
            onBeforeChange={(editor, data, value) => sqlChanged(value)}
        />
    );
};
